import styled from '@emotion/styled';

export const RecordButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1rem;
    width: 100%;
`;

export const RecordButton = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    border-radius: 8px;
    background-color: ${(props) =>
        props.isRecording
            ? '#f44336'
            : props.isProcessing
              ? '#2196f3'
              : props.status === 'completed'
                ? '#4caf50'
                : props.status === 'error'
                  ? '#ff9800'
                  : '#50aeb0'};
    color: white;
    width: 100%;
    max-width: 500px;
    height: 200px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    .mic-icon {
        font-size: 2rem;
        margin-bottom: 0.5rem;
    }

    .processing-icon {
        font-size: 2rem;
        margin-bottom: 0.5rem;
    }

    .success-icon {
        font-size: 2rem;
        margin-bottom: 0.5rem;
    }

    .error-icon {
        font-size: 2rem;
        margin-bottom: 0.5rem;
    }

    .record-text {
        font-weight: bold;
        font-size: 1rem;
    }

    .stop-text,
    .view-text,
    .hint-text,
    .try-again {
        font-size: 0.8rem;
        opacity: 0.8;
    }

    .pulsing {
        animation: pulse 1.5s infinite;
    }

    @keyframes pulse {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }
`;

export const RecordingTips = styled.div`
    margin-top: 1rem;
    padding: 0.75rem;
    background-color: #f5f5f5;
    border-radius: 8px;
    width: 100%;

    p {
        margin: 0;
        color: #555;
        &:first-of-type {
            margin-bottom: 0.5rem;
            font-weight: bold;
        }
    }
`;
export const RelativeDiv = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const RecordFloatingContainer = styled.div`
    position: fixed;
    top: 30px;
    right: 30px;
    z-index: 1050;
    background-color: #cde5dd;
    border-radius: 10px;
`;
